import { FC } from 'react';

const IconRemoveFromCart: FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5256_8615)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 4C6 2.89543 6.89543 2 8 2C9.10457 2 10 2.89543 10 4H6ZM4 4C4 1.79086 5.79086 0 8 0C10.2091 0 12 1.79086 12 4H16L15.3333 8H13.3057L13.6391 6H2.36092L3.55499 13.1644C3.63535 13.6466 4.05254 14 4.54138 14H8V16H4.54138C3.07486 16 1.82329 14.9398 1.5822 13.4932L0 4H4ZM15.682 10.7322L13.9142 12.5L15.682 14.2678L14.2677 15.682L12.5 13.9142L10.7322 15.682L9.31799 14.2678L11.0858 12.5L9.31799 10.7322L10.7322 9.31802L12.5 11.0858L14.2677 9.31802L15.682 10.7322Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_5256_8615">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export { IconRemoveFromCart };
